import React from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { getString } from "../../utilities";
import TextViewHook from "../global/textViewHook";
import { getMaxLengthValidator, getMinLengthValidator, validateEmail } from "../../utilities/forms/rules";
import { EMAIL_CHAR_LIMIT, PASSWORD_CHAR_LIMIT, PASSWORD_CHAR_MINIMUM } from "../../config";

export default function AccountFields({ errors, submitErrors, setSubmitErrors }) {
  const { getValues, trigger } = useFormContext();

  const onChange = () => {
    if (submitErrors) {
      setSubmitErrors(null);
    }
  };

  return (
    <>
      <TextViewHook
        rules={{
          required: getString("forms.errorMessages.isRequired", [getString("forms.email.4")]),
          validate: (value) => validateEmail(value, getString("forms.email.4")),
          maxLength: getMaxLengthValidator(getString("forms.email.4"), EMAIL_CHAR_LIMIT),
        }}
        errors={errors}
        className="col2"
        name="email"
        placeholder={getString("forms.email.4")}
        label={getString("forms.email.4")}
        onChange={() => {
          trigger("emailVerify");
          onChange();
        }}
      />

      <TextViewHook
        rules={{
          validate: (value) =>
            value === getValues().email || getString("forms.errorMessages.mustMatch", [getString("forms.email.4")]),
        }}
        errors={errors}
        className="col2 right"
        name="emailVerify"
        placeholder={getString("forms.adultEmailVerify")}
        label={getString("forms.adultEmailVerify")}
        onChange={() => {
          trigger("email");
          onChange();
        }}
      />

      <TextViewHook
        rules={{
          required: getString("forms.errorMessages.isRequired", [getString("forms.password.0")]),
          maxLength: getMaxLengthValidator(getString("forms.password.0"), PASSWORD_CHAR_LIMIT),
          minLength: getMinLengthValidator(getString("forms.password.0"), PASSWORD_CHAR_MINIMUM),
        }}
        errors={errors}
        className="col2"
        name="password"
        type="password"
        placeholder={getString("forms.password.0")}
        label={getString("forms.password.0")}
        onChange={() => {
          trigger("passwordVerify");
          onChange();
        }}
      />

      <TextViewHook
        rules={{
          validate: (value) =>
            value === getValues().password ||
            getString("forms.errorMessages.mustMatch", [getString("forms.password.0")]),
        }}
        errors={errors}
        className="col2 right"
        name="passwordVerify"
        type="password"
        placeholder={getString("forms.passwordVerify")}
        label={getString("forms.passwordVerify")}
        onChange={() => {
          trigger("password");
          onChange();
        }}
      />
    </>
  );
}

AccountFields.propTypes = {
  errors: PropTypes.object.isRequired,
  submitErrors: PropTypes.object,
  setSubmitErrors: PropTypes.func.isRequired,
};

AccountFields.defaultProps = {
  submitErrors: null,
};
